
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Supplier from "../pages/supplier/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/fournisseur",
    element: <Supplier />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
